import { createRouter, createWebHistory } from 'vue-router'
import { authGuard } from './guards/authGuard'

// Route modules
import dashboardRoutes from './routes/dashboard'
import clientsRoutes from './routes/clients'
import usersRoutes from './routes/users'
import rolesRoutes from './routes/roles'
import resourcesRoutes from './routes/resources'
import providersRoutes from './routes/providers'
import grantsRoutes from './routes/grants'
import keysRoutes from './routes/keys'
import logsRoutes from './routes/logs'
import systemRoutes from './routes/system'
import termsRoutes from './routes/terms'
import claimsRoutes from './routes/claims'
import registrationFieldSettingsRoutes from './routes/registrationFieldSettings'
import claimApprovalSettingsRoutes from './routes/claimApprovalSettings'
import emailSettingsRoutes from './routes/emailSettings'
import emailTemplatesRoutes from './routes/emailTemplates'
import emailConfirmationRoutes from './routes/emailConfirmation'
import familySitesRoutes from './routes/familySites'
import homeNoticesRoutes from './routes/homeNotices'
import familySiteCategoriesRoutes from './routes/familySiteCategories'

const routes = [
    // Dashboard
    ...dashboardRoutes,

    // Configuration
    ...clientsRoutes,
    ...resourcesRoutes,
    ...providersRoutes,

    // Identity
    ...usersRoutes,
    ...rolesRoutes,

    // Management
    ...grantsRoutes,
    ...keysRoutes,

    // Logs
    ...logsRoutes,

    // System
    ...systemRoutes,

    // Terms Management
    ...termsRoutes,

    // Claims Management
    ...claimsRoutes,

    // Registration Settings
    ...registrationFieldSettingsRoutes,

    // Claim Approval Settings
    ...claimApprovalSettingsRoutes,

    // Email Settings
    ...emailSettingsRoutes,

    // Email Templates
    ...emailTemplatesRoutes,

    // Email Confirmation (미인증 사용자 재발송)
    ...emailConfirmationRoutes,

    // Family Sites (STS /manage 카드 + 상단 메뉴 노출 사이트)
    ...familySitesRoutes,
    ...homeNoticesRoutes,
    ...familySiteCategoriesRoutes,

    // Error pages
    {
        path: '/error',
        name: 'error',
        component: () => import('../pages/shared/ErrorPage.vue'),
        meta: {
            layout: 'blank',
            title: 'Error',
            requiresAuth: false,
        },
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('../pages/shared/NotFoundPage.vue'),
        meta: {
            layout: 'blank',
            title: 'Not Found',
            requiresAuth: false,
        },
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        return { top: 0 }
    },
})

// Global navigation guard
router.beforeEach(authGuard)

export default router
